export interface ISize {
	_1_24: string;
	_2_24: string;
	_3_24: string;
	_4_24: string;
	_5_24: string;
	_6_24: string;
	_7_24: string;
	_8_24: string;
	_9_24: string;
	_10_24: string;
	_11_24: string;
	_12_24: string;
	_13_24: string;
	_14_24: string;
	_15_24: string;
	_16_24: string;
	_17_24: string;
	_18_24: string;
	_19_24: string;
	_20_24: string;
	_21_24: string;
	_22_24: string;
	_23_24: string;
	_1_12: string;
	_2_12: string;
	_3_12: string;
	_4_12: string;
	_5_12: string;
	_6_12: string;
	_7_12: string;
	_8_12: string;
	_9_12: string;
	_10_12: string;
	_11_12: string;
	_1_8: string;
	_2_8: string;
	_3_8: string;
	_4_8: string;
	_5_8: string;
	_6_8: string;
	_7_8: string;
	_8_8: string;
	_1_5: string;
	_2_5: string;
	_3_5: string;
	_4_5: string;
	_1_4: string;
	_2_4: string;
	_3_4: string;
	_1_3: string;
	_2_3: string;
	_1_2: string;
	_1_1: string;
}
export var Size: ISize = {
	_1_24: '1-24',
	_2_24: '2-24',
	_3_24: '3-24',
	_4_24: '4-24',
	_5_24: '5-24',
	_6_24: '6-24',
	_7_24: '7-24',
	_8_24: '8-24',
	_9_24: '9-24',
	_10_24: '10-24',
	_11_24: '11-24',
	_12_24: '12-24',
	_13_24: '13-24',
	_14_24: '14-24',
	_15_24: '15-24',
	_16_24: '16-24',
	_17_24: '17-24',
	_18_24: '18-24',
	_19_24: '19-24',
	_20_24: '20-24',
	_21_24: '21-24',
	_22_24: '22-24',
	_23_24: '23-24',
	_1_12: '1-12',
	_2_12: '2-12',
	_3_12: '3-12',
	_4_12: '4-12',
	_5_12: '5-12',
	_6_12: '6-12',
	_7_12: '7-12',
	_8_12: '8-12',
	_9_12: '9-12',
	_10_12: '10-12',
	_11_12: '11-12',
	_1_8: '1-8',
	_2_8: '2-8',
	_3_8: '3-8',
	_4_8: '4-8',
	_5_8: '5-8',
	_6_8: '6-8',
	_7_8: '7-8',
	_8_8: '8-8',
	_1_5: '1-5',
	_2_5: '2-5',
	_3_5: '3-5',
	_4_5: '4-5',
	_1_4: '1-4',
	_2_4: '2-4',
	_3_4: '3-4',
	_1_3: '1-3',
	_2_3: '2-3',
	_1_2: '1-2',
	_1_1: '1-1'
};
